// @flow
import React, { type Node } from 'react';
import classnames from 'classnames';
import invariant from 'invariant';
import stylesheet from './Sticky.scss';

const stickyTypes = {
  top: 'top',
  bottom: 'bottom',
};

type StickyType = $Keys<typeof stickyTypes>;

type Props = {|
  children: Node,
  /** Available sticky: 'top' | 'bottom' */
  sticky: StickyType,
|};

const Sticky = ({ children, sticky }: Props) => {
  invariant(
    stickyTypes[sticky],
    'You must specify a valid value for the "sticky" prop when rendering a Sticky'
  );

  const stickyClass = classnames(
    stylesheet['sticky'],
    stylesheet[`sticky--${sticky}`]
  );

  return <div className={stickyClass}>{children}</div>;
};

export default Sticky;
